import Joi from 'joi';

export const ForgotPasswordPayloadSchema = Joi.object({
  recaptchaToken: Joi.string(),
  userEmail: Joi.string(),
  postResetLink: Joi.string(),
});

export const ForgotPasswordResponseSchema = Joi.object({
  id: Joi.number(),
  message_en: Joi.string(),
  template: Joi.string(),
});

export const SetPasswordPayloadSchema = Joi.object({
  recaptchaToken: Joi.string(),
  newPassword: Joi.string(),
  passwordHash: Joi.string(),
});

export const SetPasswordResponseSchema = Joi.object({
  id: Joi.number(),
  message_en: Joi.string(),
  template: Joi.string(),
});
